import './migrationInfoDialog';

angular
   .module('org.saga.designhistory', ['org.saga.service', 'org.saga.migrationInfo'])

   .controller('DesignHistoryController', [
      '$scope',
      '$routeParams',
      'ModelHistory',
      'InstanceGroup',
      '$mdDialog',
      'Migration',
      '$translate',
      'MigrationInfoDialog',
      'NewInstance',
      function (
         $scope,
         $routeParams,
         ModelHistory,
         InstanceGroup,
         $mdDialog,
         Migration,
         $translate,
         MigrationInfoDialog,
         NewInstance
      ) {
         $scope.name = $routeParams.name;
         $scope.nameObject = { name: $routeParams.name };

         $scope.options = {};

         $scope.reload = function () {
            ModelHistory.query($scope.nameObject, function (models) {
               $scope.models = models;
               InstanceGroup.search($scope.nameObject, function (instanceCounts) {
                  angular.forEach($scope.models, function (model) {
                     Migration.status({ name: model.name, uuid: model.uuid }, function (status) {
                        model.migration = status;
                     });
                     model.instanceCount = { totalCount: 0, activeCount: 0 };
                     angular.forEach(instanceCounts, function (instanceCount) {
                        if (
                           model.name === instanceCount.name &&
                           model.uuid === instanceCount.uuid
                        ) {
                           model.instanceCount = instanceCount;
                        }
                     });
                  });
               });
            });
         };

         $scope.migratePrompt = function (uuid) {
            var dialog = $mdDialog
               .prompt()
               .title($translate.instant('ModelMigration'))
               .textContent($translate.instant('EnterUUID'))
               .placeholder('UUID')
               .ariaLabel('UUID')
               .initialValue(uuid)
               .required(true)
               .ok($translate.instant('Ok'))
               .cancel($translate.instant('Cancel'));

            $mdDialog.show(dialog).then(function (result) {
               var migrationRequest = {
                  oldVersion: { name: $scope.name, uuid: uuid },
                  newVersion: { name: $scope.name, uuid: result }
               };

               Migration.info(
                  migrationRequest,
                  function (migrationInfoResult) {
                     MigrationInfoDialog.show(migrationInfoResult, function () {
                        Migration.run(migrationRequest, function () {
                           $mdDialog
                              .show(
                                 $mdDialog
                                    .alert()
                                    .parent(angular.element(document.body))
                                    .clickOutsideToClose(true)
                                    .title($translate.instant('MigrationResult'))
                                    .textContent($translate.instant('MigrationMessage'))
                                    .ariaLabel($translate.instant('MigrationResult'))
                                    .ok('Ok')
                              )
                              .then(function () {
                                 $scope.reload();
                              });
                        });
                     });
                  },
                  function () {
                     console.log('unable to get migration info');
                  }
               );
            });
         };

         $scope.reload();

         $scope.createInstance = function (model) {
            NewInstance.run(model, function (url) {
               location.href = '/v2/tasks';
            });
         };

         $scope.clearFilter = function () {
            $scope.options.query = undefined;
            document.getElementById('search-box').focus();
         };
      }
   ]);
